(function () {
  var instances = {};

  function init(root) {
    var id = root.dataset.sectionId;
    if (!id || instances[id]) return;

    var cleanups = [];
    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    // Reading progress + chapter scroll spy
    var progress = root.querySelector('[data-mp-progress]');
    function onScroll() {
      if (!progress) return;
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var ratio = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
      progress.style.transform = 'scaleX(' + ratio + ')';
    }
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    var links = root.querySelectorAll('[data-spy]');
    if ('IntersectionObserver' in window && links.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) {
            var active = link.dataset.spy === entry.target.id;
            link.setAttribute('aria-current', active);
            var bar = link.parentNode;
            if (active && bar.scrollWidth > bar.clientWidth) {
              bar.scrollTo({ left: link.offsetLeft - 60, behavior: 'smooth' });
            }
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      root.querySelectorAll('[data-mp-spy]').forEach(function (s) { io.observe(s); });
      cleanups.push(function () { io.disconnect(); });
    }

    // Video series player
    var player = root.querySelector('[data-mp-player]');
    var eps = Array.prototype.slice.call(root.querySelectorAll('[data-mp-ep]'));
    var current = 0;
    // Adaptive HLS where the browser plays it natively (Safari/iOS, most Android); MP4 elsewhere
    var canHls = !!player && (player.canPlayType('application/vnd.apple.mpegurl') !== '' || player.canPlayType('application/x-mpegURL') !== '');
    function sourceFor(ep) {
      return canHls && ep.dataset.hls ? ep.dataset.hls : ep.dataset.src;
    }
    function pick(index, play) {
      var ep = eps[index];
      if (!ep || !player) return;
      if (index !== current) {
        player.poster = ep.dataset.poster;
        if (sourceFor(ep)) {
          player.src = sourceFor(ep);
        } else {
          player.removeAttribute('src');
          player.load();
        }
        current = index;
      }
      root.querySelector('[data-mp-now-tag]').textContent = ep.dataset.tag;
      root.querySelector('[data-mp-now-title]').textContent = ep.dataset.title;
      root.querySelector('[data-mp-now-dur]').textContent = ep.dataset.dur;
      eps.forEach(function (b, i) {
        if (i === index) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
        b.querySelector('.mp-pl__st').textContent = i === index ? 'Tocando' : 'Assistir';
      });
      if (play && sourceFor(ep)) {
        var p = player.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    eps.forEach(function (b, i) {
      on(b, 'click', function () {
        pick(i, true);
        if (window.innerWidth < 900) player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    root.querySelectorAll('[data-mp-play]').forEach(function (a) {
      on(a, 'click', function (e) {
        var watch = root.querySelector('[data-mp-watch]');
        if (!watch) return;
        e.preventDefault();
        watch.scrollIntoView({ behavior: 'smooth', block: 'center' });
        pick(Number(a.dataset.mpPlay), true);
      });
    });
    if (player) {
      on(player, 'ended', function () { if (current < eps.length - 1) pick(current + 1, true); });
    }

    // Lightbox
    var lb = root.querySelector('[data-mp-lb]');
    if (lb) {
      var lbImg = lb.querySelector('img');
      var lbCount = lb.querySelector('[data-mp-lb-count]');
      var closeBtn = lb.querySelector('[data-mp-lb-close]');
      var set = [];
      var idx = 0;
      var last = null;
      var show = function () {
        var im = set[idx].querySelector('img');
        lbImg.src = im.currentSrc || im.src;
        lbImg.alt = im.alt;
        lbCount.textContent = (idx + 1) + ' / ' + set.length;
      };
      var focusables = lb.querySelectorAll('button');
      var onKeydown = function (e) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
        else if (e.key === 'Tab') {
          // Trap focus inside the dialog while it is open
          var first = focusables[0];
          var lastFocusable = focusables[focusables.length - 1];
          if (!lb.contains(document.activeElement)) {
            e.preventDefault();
            first.focus();
          } else if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            lastFocusable.focus();
          } else if (!e.shiftKey && document.activeElement === lastFocusable) {
            e.preventDefault();
            first.focus();
          }
        }
      };
      var close = function () {
        lb.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
        if (last) last.focus();
      };
      var step = function (d) {
        idx = (idx + d + set.length) % set.length;
        show();
      };
      root.querySelectorAll('[data-g]').forEach(function (b) {
        on(b, 'click', function () {
          set = Array.prototype.slice.call(root.querySelectorAll('[data-g="' + b.dataset.g + '"]'));
          idx = set.indexOf(b);
          last = b;
          show();
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
          document.removeEventListener('keydown', onKeydown);
          document.addEventListener('keydown', onKeydown);
          closeBtn.focus();
        });
      });
      on(closeBtn, 'click', close);
      on(lb.querySelector('[data-mp-lb-prev]'), 'click', function () { step(-1); });
      on(lb.querySelector('[data-mp-lb-next]'), 'click', function () { step(1); });
      on(lb, 'click', function (e) { if (e.target === lb) close(); });
      var startX = null;
      on(lb, 'touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      on(lb, 'touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        startX = null;
      });
      cleanups.push(function () {
        document.removeEventListener('keydown', onKeydown);
        document.body.style.overflow = '';
      });
    }

    instances[id] = function () {
      cleanups.forEach(function (fn) { fn(); });
    };
  }

  function destroy(id) {
    if (!instances[id]) return;
    instances[id]();
    delete instances[id];
  }

  function initAll() {
    document.querySelectorAll('[data-mp-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mp-root]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroy(e.detail.sectionId);
  });
})();
